// import { gql } from "apollo-angular";

export const PRODUCT_FRAGMENT = /* GraphQL */
	`fragment ProductFields on Product {
	collections(first: 99) {
		edges {
			node {
				id
				title
				handle
			}
		}
	}
	availableForSale
	id
	handle
	title
	vendor
	featuredImage {
		id
		url
		height
		width
		altText
		__typename
	}
	options {
		id
		name
		optionValues {
			name
			swatch {
				color
				image {
					id
				}
			}
		}
		__typename
	}
	priceRange {
		minVariantPrice {
			amount
			currencyCode
			__typename
		}
		maxVariantPrice {
			amount
			currencyCode
			__typename
		}
		__typename
	}
	description
	descriptionHtml
	tags
	rating: metafield(namespace: "reviews", key: "rating") {
		value
	}
	features: metafield(namespace: "custom", key: "features") {
		value
	}
	fabric_name: metafield(namespace: "custom", key: "fabric_name") {
		value
	}
	returns_exchanges: metafield(namespace: "custom", key: "returns_exchanges") {
		value
	}
	product_care: metafield(namespace: "custom", key: "product_care") {
		value
	}
	sizing_recommendations: metafield(namespace: "custom", key: "sizing_recommendations") {
		value
	}
	hide_product_care: metafield(namespace: "custom", key: "hide_product_care") {
		value
	}
	confirmation_message: metafield(namespace: "custom", key: "confirmation_message") {
		value
	}
	swatch_colors: metafield(namespace: "custom", key: "swatch_colors") {
		value
	}
	swatch_image: metafield(namespace: "custom", key: "swatch_image") {
		value
	}
	swatch_rotation: metafield(namespace: "custom", key: "swatch_rotation") {
		value
	}
	style_name: metafield(namespace: "custom", key: "style_name") {
		value
	}
	metafields(
		identifiers: [
			{ namespace: "custom", key: "features" }
			{ namespace: "custom", key: "fabric_name" }
			{ namespace: "custom", key: "returns_exchanges" }
			{ namespace: "custom", key: "product_care" }
			{ namespace: "custom", key: "sizing_recommendations" }
			{ namespace: "custom", key: "hide_product_care" }
			{ namespace: "custom", key: "confirmation_message" }
			{ namespace: "custom", key: "swatch_colors" }
			{ namespace: "custom", key: "swatch_image" }
			{ namespace: "custom", key: "swatch_rotation" }
			{ namespace: "custom", key: "style_name" }
			{ namespace: "reviews", key: "rating" }
		]
	) {
		key
		value
		updatedAt
		__typename
	}
	variants(first: 46) {
		edges {
			node {
				availableForSale
				id
				barcode
				title
				sku
				quantityAvailable
				currentlyNotInStock
				image {
					url
					__typename
				}
				selectedOptions {
					name
					value
					__typename
				}
				price {
					amount
					currencyCode
					__typename
				}
				compareAtPrice {
					amount
					currencyCode
					__typename
				}
				__typename
			}
			__typename
		}
		__typename
	}
	media(first: 30) {
		edges {
			node {
				... on MediaImage {
					mediaContentType
					image {
						id
						url
						altText
						width
						height
						__typename
					}
					__typename
				}
				... on Video {
					mediaContentType
					id
					previewImage {
						url
						__typename
					}
					sources {
						mimeType
						url
						__typename
					}
					__typename
				}
				... on ExternalVideo {
					mediaContentType
					id
					embedUrl
					host
					__typename
				}
				... on Model3d {
					mediaContentType
					id
					alt
					mediaContentType
					previewImage {
						url
						__typename
					}
					sources {
						url
						__typename
					}
					__typename
				}
				__typename
			}
			__typename
		}
		__typename
	}
	__typename
}`